export default __webpack_public_path__ + "static/media/napaLogo_horizontal_darkBackground_fr.084146db.svg";